import angular from 'angular';
import CategoriesFilterModule from './categories-filter/categories-filter';
import FeaturedProductsModule from './featured-products/featured-products';
import NewProductsModule from './new-products/new-products';
import MostSelledProductsModule from './most-selled-products/most-selled-products';
import RelatedProductsModule from './related-products/related-products';
import CatalogService from './catalog.service';
import ModalQuantityCartController from './modal-quantity-cart/modal-quantity-cart.controller';
import ModalConfirmationController from './modal-confirmation/modal-confirmation.controller';
import CategoryModule from './category/category';
import ProductsListModule from './products-list/products-list';
import ProductDetailModule from './product-detail/product-detail';
import comparModule from './compare-products/compare-products';
import ProductNotFound from './product-not-found/product-not-found';
import fastSearch from './fast-search/fast-search';

let CatalogModule = angular.module('catalog', [
  CategoriesFilterModule.name,
  fastSearch.name,
  ProductDetailModule.name,
  ProductNotFound.name,
  comparModule.name,
  NewProductsModule.name,
  ProductsListModule.name,
  RelatedProductsModule.name,
  CategoryModule.name,
  MostSelledProductsModule.name,
  FeaturedProductsModule.name
])
  .controller('ModalQuantityCartController', ModalQuantityCartController)
  .controller('ModalConfirmationController', ModalConfirmationController)
  .service('CatalogService', CatalogService);

export default CatalogModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/catalog.js
 **/